import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  .inputNone {
    opacity: 0;
    width: 1px;
  }
  .modalContainer {
    width: 90%;
    max-width: 1100px;
    padding: 20px;
    height: 90%;
    border-radius: 5px;
    overflow-y: scroll;
    background-color: ${({ theme }) => theme.colors.white};
  }
  .modalHeader {
    display: flex;
    padding-bottom: 15px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray};
  }

  .modalContainer > span {
    display: flex;
    justify-content: flex-end;

    padding: 15px;
    height: 12px;
  }
  .dynamicValueList {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    box-shadow: 2px 0px 10px rgba(3, 3, 3, 0.1);
    width: 100%;
  }
  .dynamicValueList > div {
    text-align: center;
  }
  .addDynamicValue {
    display: flex;
  }
  .modalContainer > form {
    display: flex;
    justify-content: center;
    padding: 15px;
    gap: 25px;
    flex-direction: column;
  }
  .urlInput {
    display: flex;
  }
  form > p {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .smsSettings {
    padding-top: 25px;
    padding-bottom: 25px;
  }
  .suggestedShortcodes {
    color: #767676;
    font-size: 12px;
    font-family: "Roboto";
    font-weight: 400;
    line-height: 16px;
  }
  .modalContainer > span > button {
    background-color: ${({ theme }) => theme.colors.secondary};

    color: ${({ theme }) => theme.colors.gray};
    border: none;
    border-radius: 5px;
  }
`;
